export default __webpack_public_path__ + "static/media/expGreen.16b06cc5.svg";